import { Container, Paper, Stack, Text, Title } from "@mantine/core";
import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { getAssignmentPageBySlug } from "../../data/assignmentPages";
import Seo from "../../seo/Seo";
import {
  createBreadcrumbSchema,
  createOrganizationSchema,
} from "../../seo/utils";
import { getAssignmentPagePath } from "../../utils/routes";
import Breadcrumbs from "../AssignmentHelp/Breadcrumbs";
import GetHelpForm from "./GetHelpForm";
import "./OrderFormPage.css";

function OrderFormPage() {
  const [searchParams] = useSearchParams();
  const sourceSlug = searchParams.get("from") || "";
  const sourcePage = getAssignmentPageBySlug(sourceSlug);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  const orderTitle = sourcePage
    ? `Order ${sourcePage.title}`
    : "Order Assignment Help";
  const orderDescription = sourcePage
    ? `Fill in the form below for ${sourcePage.title.toLowerCase()} and we will reach out to you on WhatsApp or email with the next steps.`
    : "Fill in the form below and we will reach out to you on WhatsApp or email with the next steps.";

  const breadcrumbs = [
    { label: "Home", href: "/" },
    ...(sourcePage
      ? [{ label: sourcePage.title, href: getAssignmentPagePath(sourcePage.slug) }]
      : []),
    { label: "Order Form" },
  ];

  const breadcrumbSchemaItems = [
    { name: "Home", path: "/" },
    ...(sourcePage
      ? [{ name: sourcePage.title, path: getAssignmentPagePath(sourcePage.slug) }]
      : []),
    {
      name: "Order Form",
      path: sourcePage
        ? `/order-form?from=${sourcePage.slug}`
        : "/order-form",
    },
  ];

  return (
    <main className="order-form-page">
      <Seo
        title={`${orderTitle} | SubjectBuddy`}
        description={orderDescription}
        schema={[
          createOrganizationSchema(),
          createBreadcrumbSchema(breadcrumbSchemaItems),
        ]}
      />

      <Container size="md" className="order-form-shell">
        <Breadcrumbs items={breadcrumbs} />

        <Paper className="order-form-card" radius="xl" p="xl">
          <Stack gap="lg" align="center">
            <div className="order-form-heading">
              <Title order={1}>{orderTitle}</Title>
              <Text>{orderDescription}</Text>
            </div>

            <div className="order-form-wrap">
              <GetHelpForm
                formSize="lg"
                submitLabel="Submit Request"
                showEmailField
              />
            </div>
          </Stack>
        </Paper>
      </Container>
    </main>
  );
}

export default OrderFormPage;
